/** Stable colour per department name (2026-10-27): the intake band's
 *  department bar and any future department chip read the same hue, so a
 *  department looks the same everywhere without a lookup table to maintain.
 *  "No department" is always grey. */
export const NO_DEPARTMENT = "No department";

const HUES = [
  { bg: "#3b5bdb", fg: "#ffffff" }, // indigo
  { bg: "#0ca678", fg: "#ffffff" }, // teal
  { bg: "#e8590c", fg: "#ffffff" }, // orange
  { bg: "#7048e8", fg: "#ffffff" }, // violet
  { bg: "#1098ad", fg: "#ffffff" }, // cyan
  { bg: "#d6336c", fg: "#ffffff" }, // pink
  { bg: "#2f9e44", fg: "#ffffff" }, // green
  { bg: "#f08c00", fg: "#1f2937" }, // amber
  { bg: "#1971c2", fg: "#ffffff" }, // blue
  { bg: "#a61e4d", fg: "#ffffff" }, // wine
];

export function departmentColor(name: string | null | undefined): { bg: string; fg: string } {
  const n = (name ?? "").trim();
  if (!n || n === NO_DEPARTMENT) return { bg: "#cbd5e1", fg: "#1f2937" };
  let h = 0;
  for (let i = 0; i < n.length; i++) h = (h * 31 + n.charCodeAt(i)) >>> 0;
  return HUES[h % HUES.length];
}

/** The date a request was submitted: the Freshservice ticket date when
 *  it came from the service desk, else the day the row was created. */
export function submittedOn(p: { requested_at?: string | null; created_at?: string | null }): string | null {
  return (p.requested_at || p.created_at || null)?.slice(0, 10) ?? null;
}

export function ageDays(iso: string | null | undefined, today = new Date()): number | null {
  if (!iso) return null;
  const d = new Date(iso + "T00:00:00");
  if (Number.isNaN(d.getTime())) return null;
  const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.max(0, Math.round((t0.getTime() - d.getTime()) / 86_400_000));
}
